import { useState, useContext, useEffect } from "react"
import { CMultiSelect, CToggle, ReportSelectPeriod, TablePage, toast, CSelect, CSkeletonTable, ModalDelete, TablePagination, CModal, ModalFilterUser } from "../../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../../context";
import { AccessLevelApi, DeleteAccessLevelApi, ModuleApi } from "../../../api";
import { Link } from 'react-router-dom'
import moment from "jalali-moment";


export const AccessLevel = () => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [visibleDelete, setVisibleDelete] = useState<boolean>(false)
    const [visibleAccess, setVisibleAccess] = useState<boolean>(false)
    const [selectViewAccess, setSelectViewAccess] = useState<any>([])
    const [selectDelete, setSelectDelete] = useState<any>(null)
    const [jsonParms, setJsonParms] = useState<any>({ 'page': 1 })
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [tableData, setTableData] = useState<any>([])
    const [tableDataKeeper, setTableDataKeeper] = useState<any>([])
    const [detailModule, setDetailModule] = useState<any>(null)
    const col: any = [
        {
            title: "نام سطح",
            render: (i: any) => (<>{i.name && i.name != null && i.name}</>)
        },
        {
            title: "گروه شغلی",
            render: (i: any) => (
                <div className=" w-[90%] mt-2 flex justify-center items-center w-6/12 flex-wrap">
                    {i.exceptions != undefined && i.exceptions != null && i.exceptions.map((item: any, index: any) =>
                        <div className="m-1 flex items-center justify-center text-white text-[10px] bg-dayan-orange-50 rounded-[8px] px-[8px] py-[4px]">{item.name}</div>
                    )}
                </div>
            )
        },
        {
            title: "مشاهده دسترسی ها",
            render: (i: any) => (
                <div onClick={() => handelViewAccess(i.accesses)} className="flex items-center justify-center  h-[35px] w-[120px] cursor-pointer rounded-lg bg-dayan-gray-200 text-white text-[11px]">
                    <svg x="0px" y="0px" viewBox="0 0 512 512" className={`  w-[20px] fill-white ml-2 `}>
                        <use xlinkHref="/assetes/svg/eye.svg#eye" />
                    </svg>
                    <span > دسترسی ها</span>

                </div>
            )
        },
        {
            title: "وضعیت ",
            render: (i: any) => (
                <>
                    {i.status && i.status != null && i.status == 1 ? "فعال" : "غیرفعال"}
                </>
            )
        },
        {
            title: "اقدامات",
            render: (i: any) => (
                <div className="flex items-center w-full justify-around h-[60px]">
                    <Link to={`/p/settings/access-level/${i.id}`}>
                        <img src="/assetes/svg/edit.svg" className="w-[20px] cursor-pointer" />
                    </Link>
                    <img src="/assetes/svg/trash.svg" onClick={() => startDelete(i.id)} className="w-[20px] cursor-pointer" />
                </div>)
        },

    ]

    const getModuleData = async () => {
        try {
            let res = await ModuleApi()
            if (res?.data?.modules != null && Array.isArray(res?.data?.modules)) {
                for (let j of res.data.modules) {
                    if (j.id == 1) {
                        setDetailModule(j)
                    }
                }
            }
            CtxLoad.setDisplayLoadingSkelton(false)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    const handelSelectAccessStatus = (e: any) => {
        let data = [];
        if (e.target.value == 'all') {
            return setTableData(tableDataKeeper)
        }
        for (let i of tableDataKeeper) {
            if (i.status == e.target.value) {
                data.push(i)
            }
        }
        setTableData(data)
    }

    const handelViewAccess = (list: any) => {
        if (list && Array.isArray(list)) {
            setSelectViewAccess(list);
            setVisibleAccess(true)
        }
    }

    const changePage = (type: string) => {
        let data = { ...jsonParms };
        if (type == 'next') {
            data['page'] = currentPage + 1;
        }
        else {
            data['page'] = currentPage - 1;
        }
        setJsonParms(data)
        getData(data)
    }

    const startDelete = (id: any) => {
        setSelectDelete(id)
        setVisibleDelete(true)
    }

    const DeleteRoll = async () => {
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await DeleteAccessLevelApi(selectDelete)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.status) {
            toast("با موفقیت حذف گردید", { type: "success" })
            setSelectDelete(null)
            setVisibleDelete(false)
            getData(jsonParms)
        }
        else {
            toast("خطایی رخ داده است", { type: "error" })
        }
    }



    const getData = async (parms: any) => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await AccessLevelApi(parms)
            setTableData(res.data.groups.data)
            setTableDataKeeper(res.data.groups.data)
            setCurrentPage(res.data.groups.current_page)
            setLastPage(res.data.groups.last_page)
            // CtxLoad.setDisplayLoadingSkelton(false)
            getModuleData()
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        document.title = "سطوح دسترسی | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 5, })
        getData(jsonParms)

    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px] md:mb-0">مدیریت سطوح دسترسی</h1>
            {CtxLoad.displayLoadingSkelton == false && detailModule?.company_has_this_module == true && detailModule?.company_expire_date_for_this_moule != null && new Date(detailModule?.company_expire_date_for_this_moule).getTime() >= new Date(moment().locale('fa').format('YYYY/M/D')).getTime() &&
                <>
                    {localStorage.getItem('groupAccess') == '-1' &&
                        <>
                            <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                                <div className="w-full md:w-[49%] flex flex-wrap items-center justify-between">
                                    <div className="w-full md:w-[49%] h-[40px] sm:h-[50px] bg-white rounded-md shadow text-sm">
                                        <CSelect placeholder={'انتخاب وضعیت'} onChange={(e: any) => handelSelectAccessStatus(e)} >
                                            <option value={1}>سطوح فعال</option>
                                            <option value={0}>سطوح غیرفعال</option>
                                            <option value={'all'}>همه</option>
                                        </CSelect>
                                    </div>
                                </div>
                                <div className=" w-full md:w-fit flex items-center md:mt-0 mt-[7px]">
                                    <button className=" w-full md:w-[170px] h-[30px] md:h-[50px] bg-dayan-gray-200 rounded-md md:text-sm text-[11px] text-white">
                                        <Link to='/p/settings/access-level/add' className=" w-full h-full flex justify-center items-center">
                                            + افزودن سطح دسترسی
                                        </Link>
                                    </button>
                                </div>
                            </div>

                            <div className=" w-full mt-[20px]">
                                {CtxLoad.displayLoadingSkelton == false ?
                                    <TablePage columns={col} data={tableData} >
                                        <TablePagination currentPage={currentPage} lastPage={lastPage} onChange={changePage} />
                                    </TablePage>
                                    :
                                    <CSkeletonTable />
                                }
                            </div>
                        </>
                    }

                    <ModalDelete visible={visibleDelete} setVisible={setVisibleDelete} onOk={DeleteRoll} loading={CtxLoad.displayLoadingBtn} />

                    <CModal visible={visibleAccess} setVisible={setVisibleAccess} radius={'10px'} uId="Mo-viewAccess" >
                        <div className="w-full flex flex-wrap">
                            {selectViewAccess.map((item: any, index: number) =>
                                <div key={index} className="w-[50%]  p-2">
                                    <div className="w-full min-h-[45px] cursor-pointer text-[12px] px-2 flex items-center bg-[#f9f9f9] shadow rounded-lg">
                                        <div className={`w-[20px] h-[20px]  rounded ml-2 flex items-center justify-center bg-dayan-orange-50 `} >
                                            <svg x="0px" y="0px" viewBox={'0 0 405.272 405.272'} className={`fill-white h-[10px] `}>
                                                <use xlinkHref="/assetes/svg/check.svg#check" />
                                            </svg>
                                        </div>
                                        <span>{item.title}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="flex justify-end mt-[40px]">
                            <button type={'button'} onClick={() => { setVisibleAccess(false) }} className="w-[80px] mx-2 h-10 bg-dayan-gray-200  flex items-center justify-center rounded-[5px] text-white">
                                <span>بستن</span>
                            </button>
                        </div>
                    </CModal>
                </>
            }

            {CtxLoad.displayLoadingSkelton == false && detailModule?.company_has_this_module == false &&
                <div className=" w-full h-[200px] mt-[40px] rounded-[10px] flex flex-col justify-center items-center bg-white shadow">
                    <span className=" mt-6">این افزونه غیر فعال میباشد</span>
                    <button className=" w-full md:w-[170px] h-[30px] md:h-[40px] mt-[30px] bg-dayan-gray-200 rounded-md md:text-sm text-[11px] text-white">
                        <Link to='/p/module' className=" w-full h-full flex justify-center items-center">
                            فعال سازی افزونه
                        </Link>
                    </button>
                </div>
            }

            {CtxLoad.displayLoadingSkelton == false && detailModule?.company_has_this_module == true && detailModule?.company_expire_date_for_this_moule != null && new Date(detailModule?.company_expire_date_for_this_moule).getTime() < new Date(moment().locale('fa').format('YYYY/M/D')).getTime() &&
                <div className=" w-full h-[200px] mt-[40px] rounded-[10px] flex flex-col justify-center items-center bg-white shadow">
                    <span className=" mt-6">تاریخ استفاده از افزونه منقضی شده است.</span>
                    <button className=" w-full md:w-[170px] h-[30px] md:h-[40px] mt-[30px] bg-dayan-gray-200 rounded-md md:text-sm text-[11px] text-white">
                        <Link to='/p/module' className=" w-full h-full flex justify-center items-center">
                            تمدید افزونه
                        </Link>
                    </button>
                </div>
            }

            {CtxLoad.displayLoadingSkelton == true && <CSkeletonTable />}

        </div>
    )
}
